import React from 'react';
import Svg from '@bibliocommons/svg';

export default function UnAvailableGroupIcon() {
  return (
    <Svg width="12" height="12" viewBox="0 0 12 12">
      <path
        fill="#A82009"
        fillRule="evenodd"
        d="M6,12 C2.6862915,12 0,9.3137085 0,6 C0,2.6862915 2.6862915,0 6,0 C9.3137085,0 12,2.6862915 12,6 C12,9.3137085 9.3137085,12 6,12 Z M4,4.7 C3.28202983,4.7 2.7,5.28202983 2.7,6 C2.7,6.71797017 3.28202983,7.3 4,7.3 L8,7.3 C8.71797017,7.3 9.3,6.71797017 9.3,6 C9.3,5.28202983 8.71797017,4.7 8,4.7 L4,4.7 Z"
      />
    </Svg>
  );
}
